/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointstartfrostfreeamb4Inputs */



/**
* | output |
* | --- |
* | "Frost-free ambient temperature setpoint" |
*
* @param {Br_History_Key_Setpointstartfrostfreeamb4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointstartfrostfreeamb4 = /** @type {((inputs?: Br_History_Key_Setpointstartfrostfreeamb4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointstartfrostfreeamb4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free ambient temperature setpoint")
	return /** @type {LocalizedString} */ ("Température d'ambiance d'allumage des chaudières")
});
export { br_history_key_setpointstartfrostfreeamb4 as "br_history_key_setpointStartFrostFreeAmb" }